import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { AppServiceService } from 'src/app/app-service.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppEnum } from '../../../providers/app.enum';
import Swal from 'sweetalert2';
import trimCanvas from 'trim-canvas';
declare var $;

@Component({
  selector: 'app-patient-info',
  templateUrl: './patient-info.component.html',
  styleUrls: ['./patient-info.component.scss']
})

export class PatientInfoComponent implements OnInit, AfterViewInit {
  @ViewChild('sigpadname') signaturePad: SignaturePad;
  @ViewChild('sigpaddate') DatePad: SignaturePad;

  public appSetting;
  public setLanguage;
  public patientType;
  public DBName;
  public I_Name;
  public I_DOB;
  public T_Name;
  public T_DOB;
  public saveMode;
  public idealTimer = null;
  public timerForName = null;
  public timerForDate = null;
  public boolInsert = true;

  public signaturePadOptions: object = {};
  public signaturePadOptionsTwo: object = {};

  constructor(public appService: AppServiceService, public router: Router, public http: HttpClient, public appEnum: AppEnum) { }

  ngOnInit() {
    this.appService.getURL();
    const ths = this;

    const jsonData = this.appService.decryptData(localStorage.getItem('LogInDetails'));
    this.appSetting = JSON.parse(jsonData);

    if (this.appSetting.Language === this.appEnum.Entitylanguage.language_english) {
      this.setLanguage = this.appEnum.English;
    } else if (this.appSetting.Language === this.appEnum.Entitylanguage.language_chinese) {
      this.setLanguage = this.appEnum.Chinese;
    } else {
      this.setLanguage = this.appEnum.English;
    }

    this.DBName = this.appSetting.DbName;

    this.patientType = '2';
    $('#newPt').css({ 'border': '0px solid #fff' });
    $('#extPt').css({ 'border': '2px solid #5207FF' });

    this.signaturePadOptions = {
      minWidth: 1,
      canvasWidth: $('.dynamicWidth-name').width(),
      canvasHeight: 160
    };

    this.signaturePadOptionsTwo = {
      minWidth: 1,
      canvasWidth: $('.dynamicWidth-date').width(),
      canvasHeight: 160
    };

    if (this.idealTimer != null) {
      clearTimeout(this.idealTimer);
    }

    this.idealTimer = setTimeout(() => {
      clearTimeout(this.idealTimer);
      this.router.navigate(['/Patient/SignIn']);
    }, 60000);

    $('#textName').keyup( () => {
      if (ths.idealTimer != null) {
        clearTimeout(ths.idealTimer);
      }
      if (ths.timerForDate != null) {
        clearTimeout(ths.timerForDate);
      }
      if (ths.timerForName != null) {
        clearTimeout(ths.timerForName);
      }

      const textName = $('#textName').val().length;
      const textDate = $('#input-date').val().length;

      if (textName > 0 && textDate > 0) {
        $('.btnDone').prop('disabled', false);
        $('.btnDone').css('cursor', 'pointer');
      } else {
        $('.btnDone').prop('disabled', true);
        $('.btnDone').css('cursor', 'not-allowed');
      }

      if (textDate > 0 && textName > 0) {
        ths.timerForName = setTimeout(() => {
          clearTimeout(ths.timerForName);
          ths.insertPatientData();
        }, 30000);

      } else if (textName > 0 && textDate == 0) {
        ths.timerForName = setTimeout(() => {
          clearTimeout(ths.timerForName);
          ths.router.navigate(['/Patient/SignIn']);
        }, 30000);
      }
    });

    $('#input-date').keyup( (event) => {
      if (ths.idealTimer != null) {
        clearTimeout(ths.idealTimer);
      }
      if (ths.timerForName != null) {
        clearTimeout(ths.timerForName);
      }
      if (ths.timerForDate != null) {
        clearTimeout(ths.timerForDate);
      }

      const textDate = $('#input-date').val().length;
      const textName = $('#textName').val().length;

      if (textDate > 0 && textName > 0) {
        $('.btnDone').prop('disabled', false);
        $('.btnDone').css('cursor', 'pointer');
      } else {
        $('.btnDone').prop('disabled', true);
        $('.btnDone').css('cursor', 'not-allowed');
      }

      if (textDate > 0 && textName > 0) {
        ths.timerForDate = setTimeout(() => {
          clearTimeout(ths.timerForDate);
          ths.insertPatientData();
        }, 30000);

      } else if (textDate > 0 && textName == 0) {
        ths.timerForDate = setTimeout(() => {
          clearTimeout(ths.timerForDate);
          ths.router.navigate(['/Patient/SignIn']);
        }, 30000);
      }
    });

    $(':input').inputmask();
  }

  ngAfterViewInit() {
    this.signaturePad.set('minWidth', 1);
    this.signaturePad.clear();
    this.DatePad.set('minWidth', 1);
    this.DatePad.clear();    
  }

  clearSignaturePad() {
    this.signaturePad.clear();
    $('.btnDone').prop('disabled', true);
    $('.btnDone').css('cursor', 'not-allowed');
  }

  clearDatePad() {
    this.DatePad.clear();
    $('.btnDone').prop('disabled', true);
    $('.btnDone').css('cursor', 'not-allowed');
  }

  drawNameStart() {
    $('#textInput').hide();
  }

  drawNameComplete() {
    if (this.idealTimer != null) {
      clearTimeout(this.idealTimer);
    }
    if (this.timerForDate != null) {
      clearTimeout(this.timerForDate);
    }
    if (this.timerForName != null) {
      clearTimeout(this.timerForName);
    }

    if (!this.signaturePad.isEmpty() && !this.DatePad.isEmpty()) {
      $('.btnDone').prop('disabled', false);
      $('.btnDone').css('cursor', 'pointer');
    } else {
      $('.btnDone').prop('disabled', true);
      $('.btnDone').css('cursor', 'not-allowed');
    }

    if (!this.signaturePad.isEmpty() && !this.DatePad.isEmpty()) {
      this.timerForName = setTimeout(() => {
        clearTimeout(this.timerForName);
        this.insertPatientData();
      }, 30000);

    } else if (!this.signaturePad.isEmpty() && this.DatePad.isEmpty()) {
      this.timerForDate = setTimeout(() => {
        clearTimeout(this.timerForDate);
        this.router.navigate(['/Patient/SignIn']);
      }, 30000);
    }
  }

  drawDateStart() {
    $('#textInput').hide();
  }

  drawDateComplete() {
    if (this.idealTimer != null) {
      clearTimeout(this.idealTimer);
    }
    if (this.timerForName != null) {
      clearTimeout(this.timerForName);
    }
    if (this.timerForDate != null) {
      clearTimeout(this.timerForDate);
    }

    if (!this.signaturePad.isEmpty() && !this.DatePad.isEmpty()) {
      $('.btnDone').prop('disabled', false);
      $('.btnDone').css('cursor', 'pointer');
    } else {
      $('.btnDone').prop('disabled', true);
      $('.btnDone').css('cursor', 'not-allowed');
    }

    if (!this.signaturePad.isEmpty() && !this.DatePad.isEmpty()) {
      this.timerForDate = setTimeout(() => {
        clearTimeout(this.timerForDate);
        this.insertPatientData();
      }, 30000);

    } else if (!this.DatePad.isEmpty() && this.signaturePad.isEmpty()) {
      this.timerForDate = setTimeout(() => {
        clearTimeout(this.timerForDate);
        this.router.navigate(['/Patient/SignIn']);
      }, 30000);
    }
  }

  insertPatientData() {
    const todayDate: any = new Date();
    const getDate: any = new Date($('#input-date').val());

    if ((todayDate - getDate) < 0) {
      Swal.fire('', 'Please enter valid date of birth.' , 'info');
      return ;
    }

    $('.btnDone').prop('disabled', true);
    $('.btnDone').css('cursor', 'not-allowed');
    
    const url = this.appService.apiUrl + '?action=SAVE';
   
    if (this.idealTimer != null) {
      clearTimeout(this.idealTimer);
    }
    if (this.timerForName != null) {
      clearTimeout(this.timerForName);
    }
    if (this.timerForDate != null) {
      clearTimeout(this.timerForDate);
    }

    const d = new Date();
    const sDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() +
                   ':' + d.getMinutes() + ':' + d.getSeconds();

    const TName = this.appService.encryptData($('#textName').val());
    const TDOB = this.appService.encryptData($('#input-date').val());

    if ($('#textName').val().length > 0) {
      this.saveMode = '2';
      this.I_Name = '';
      this.I_DOB = '';
      this.T_Name = TName.toString();
      this.T_DOB = TDOB.toString();
    } else {
      this.saveMode = '1';
      this.I_Name = this.trimImage(0);
      this.I_DOB = this.trimImage(1);
      this.T_Name = '';
      this.T_DOB = '';
    }

    const dataJson = {
      dbName:this.DBName,
      type: this.patientType,
      saveMode: this.saveMode,
      T_Name: this.T_Name,
      T_DOB: this.T_DOB,
      I_Name: this.I_Name,
      I_DOB: this.I_DOB,
      entryTime: sDate
    };

    if(this.boolInsert){
      this.boolInsert = false;
      
      this.appService.postData(url, JSON.stringify(dataJson)).subscribe(data => {
        if (data === 'Success') {
          this.boolInsert = false;
          let mesg;
          if (this.appSetting.Language !== 'English') {
            mesg = 'You have successfully signed In \n Please have a seat' + '\n\n' + this.setLanguage.Please_have_a_seat;
          } else {
            mesg = this.setLanguage.Please_have_a_seat;
          }
  
          Swal.fire({
            type: 'success',
            title: mesg,
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 2000
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              this.router.navigate(['/Patient/SignIn']);
            }
          });
        }
      });
    }
  }

  getPatientType(patientType) {
    this.patientType = patientType;

    if (patientType === '1') {
      $('#newPt').css({ 'border': '2px solid #5207FF' });
      $('#extPt').css({ 'border': '0px solid #fff' });

    } else {
      $('#newPt').css({ 'border': '0px solid #fff' });
      $('#extPt').css({ 'border': '2px solid #5207FF' });
    }
  }

  onFocus() {
    if ($(window).width() > 768) {
      window.scrollTo(0, 80);
      document.body.scrollTop = 80;
      $('#signInput').hide();
    } else {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      $('#signInput').hide();
    }
  }

  trimImage(index){
    let copy = document.querySelectorAll('canvas');
    var trimedCanvas = trimCanvas(copy[index]);
    var scaledCanvas = document.createElement('canvas');

    var maxW = 120;
    var maxH = 40;

    var iw = trimedCanvas.width;
    var ih = trimedCanvas.height;
  
    var scale = Math.min((maxW/iw),(maxH/ih));
    var iwScaled = iw*scale;
    var ihScaled = ih*scale;

    scaledCanvas.width = iwScaled;
    scaledCanvas.height = ihScaled;
    
    var ctx = scaledCanvas.getContext('2d');
    ctx.drawImage(trimedCanvas, 0, 0, scaledCanvas.width, scaledCanvas.height);
    var trimedData = scaledCanvas.toDataURL("image/png");
    
    copy[index].width = index == 0 ? $('.dynamicWidth-name').width() : $('.dynamicWidth-date').width();
    copy[index].height = 160;

    return trimedData;
  }
}
